import { Controller } from '@hotwired/stimulus'
import { get, post } from '@rails/request.js'

export default class extends Controller {
  static targets = ['select', "upload", "content"]
  static values = {
    url: String,
    uploadUrl: String,
    param: String
  }

  connect() {
    console.log(this.uploadUrlValue, this.paramValue)
    if (this.selectTarget.id === '') {
      this.selectTarget.id = Math.random().toString(36)
    }
  }

  change(event) {
    let params = new URLSearchParams()
    params.append(this.paramValue, event.target.selectedOptions[0].value)
    params.append('target', this.selectTarget.id)

    get(`${this.urlValue}?${params}`, {
      responseKind: 'turbo-stream'
    })
  }

  async upload(event) {
    let formData = new FormData()
    formData.append('file', event.target.files[0])

    console.log(this.uploadUrlValue)
    const response = await post(this.uploadUrlValue, {
      responseKind: 'json',
      body: formData
    })
    
    if (response.ok) {
      const body = await response.json
          console.log(body)
      const file_url = "https://files.tzpxks.cn/"
      this.contentTarget.value += `<img src="${file_url}${body.key}" alt="${body.key}" />`
    }
  }
}
